import RenderTabs from '../../misc/Tabs';
import React, { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logs from './Logs';
import InstancePhaseTable from '../components/instancePhase/InstancePhaseTable';
import { useParams, Link, Route, Routes, Navigate } from 'react-router-dom'
import * as Tab from '../../../util/TabValue';
import * as Helper from '../../../util/Helper';
import { CoreModuleInstance } from '../../../models/CoreModels';
import Loading from '../../misc/Loading';
import { useTranslation } from 'react-i18next';
import { getModuleInstance } from '../../../store/ModuleInstanceAction';
import { RequestState } from '../../../models/RequestState';
import StatusCode from '../../../util/StatusCode';
import { RootState } from '../../../store/store';


const InstanceLogs = () => {
    const { t } = useTranslation(['configuration']);

    const { moduleId, moduleInstanceId } = useParams();
    const dispatch = useDispatch();
    const moduleInstance = useSelector<RootState, RequestState<CoreModuleInstance>>(state => state.moduleInstance.moduleInstance);

    useEffect(() => {
        if (moduleId && moduleInstanceId) {
            getModuleInstance(moduleId, moduleInstanceId)(dispatch);
        }
    }, [dispatch, moduleId, moduleInstanceId]);

    const tabs = [
        Tab.Tabs.InstanceLogs,
        Tab.Tabs.InstancePhaseStatistics,
    ];

    let displayName: string = "";
    let timeStamp: string = "";
    let completed: boolean = false;
    if (moduleInstance.code === StatusCode.COMPLETE) {
        displayName = ` / ${moduleInstance.data.title}`;
        timeStamp = `/ ${Helper.formatDate(moduleInstance.data.startedAt)}`;
        completed = Boolean(moduleInstance.data?.completedAt)
    }

    if (!moduleId || !moduleInstanceId) {
        return;
    }

    return (
        <div className="container">
            <div className="pr-40 pl-40 pt-40">
                <h2><Link to={`/module/${moduleId}/moduleInstanceRun`}>{t('log.title', { ns: 'configuration' })}</Link> {displayName} {timeStamp}</h2>
                <RenderTabs
                    tabs={tabs}
                    id={moduleId}
                    url="module"
                    id2={moduleInstanceId}
                    url2="instance"
                />
                <div className="tab-border" />
            </div>

            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path={Tab.Tabs.InstanceLogs.url} element={<Logs />} />
                    <Route path={Tab.Tabs.InstancePhaseStatistics.url} element={<InstancePhaseTable completed={completed} />} />
                    <Route path="*" element={<Navigate replace={true} to={`/module/${moduleId}/instance/${moduleInstanceId}/${Tab.Tabs.InstanceLogs.url}`} />} />
                </Routes>
            </Suspense>
        </div>
    );
};

export default InstanceLogs;
